import LandingPageForm from '../components/LandingPageForm';

export default function LawnSignLandingPage() {
  return (
    <LandingPageForm 
      cityName="Los Angeles County"
      neighborhood="Los Angeles County"
      sourceTag="qr-lawn-sign"
      headline="Proudly Serving Your Neighborhood. Ready to Elevate Your Property?"
      description="Professional exterior property maintenance trusted by your neighbors across Los Angeles County."
      pageTitle="Lawn Sign | Sunlight Grounds Care"
    />
  );
}
